import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class UrlMixin extends Vue {
  get pdfBaseUrl(): string {
    return process.env.VUE_APP_PDF_BASE_URL;
  }

  get manageBaseUrl(): string {
    return process.env.VUE_APP_MANAGE_BASE_URL;
  }

  get bizMypageBaseUrl(): string {
    return process.env.VUE_APP_BIZ_MYPAGE_BASE_URL;
  }

  get bizBaseUrl(): string {
    return process.env.VUE_APP_BIZ_BASE_URL;
  }
}
